import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["href"]
const _hoisted_2 = { class: "product-card__img-wrap" }
const _hoisted_3 = {
  key: 0,
  class: "product-card__missing-finish-cover"
}
const _hoisted_4 = ["src"]
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "product-card__finishes" }
const _hoisted_7 = { class: "text-smaller" }
const _hoisted_8 = { class: "product-card__text-content" }
const _hoisted_9 = { class: "product-card__title" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("a", {
    class: "product-card",
    href: $props.url
  }, [
    _createElementVNode("div", {
      class: _normalizeClass([$props.isFinishImageMissing ? `missing-finish` : ``, `product-card__visual-content`])
    }, [
      ($setup.availabilitySlug === $setup.avblNew)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(['product-card__flag', $setup.availabilitySlug && `product-card__flag--${$setup.availabilitySlug}`])
          }, [
            _createElementVNode("span", null, _toDisplayString($props.translations.New), 1 /* TEXT */)
          ], 2 /* CLASS */))
        : ($setup.availabilitySlug === $setup.avblDiscontinued)
          ? (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: _normalizeClass(['product-card__flag', $setup.availabilitySlug && `product-card__flag--${$setup.availabilitySlug}`])
            }, [
              _createElementVNode("span", null, _toDisplayString($props.translations.Discontinued), 1 /* TEXT */)
            ], 2 /* CLASS */))
          : ($setup.availabilitySlug === $setup.avblComingSoon)
            ? (_openBlock(), _createElementBlock("div", {
                key: 2,
                class: _normalizeClass(['product-card__flag', $setup.availabilitySlug && `product-card__flag--${$setup.availabilitySlug}`])
              }, [
                _createElementVNode("span", null, _toDisplayString($props.translations.ComingSoon), 1 /* TEXT */)
              ], 2 /* CLASS */))
            : (_openBlock(), _createElementBlock("div", {
                key: 3,
                class: _normalizeClass(['product-card__flag', $setup.availabilitySlug && `product-card__flag--${$setup.availabilitySlug}`])
              }, null, 2 /* CLASS */)),
      _createElementVNode("div", _hoisted_2, [
        ($props.isFinishImageMissing)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString($props.translations.NoVariantImage), 1 /* TEXT */))
          : _createCommentVNode("v-if", true),
        _createCommentVNode("\t\t\t\t<img v-if=\"beautyImageUrl\" :src=\"beautyImageUrl\" alt=\"product image\" class=\"product-card__img-beauty\" />"),
        ($props.imageUrl)
          ? (_openBlock(), _createElementBlock("img", {
              key: 1,
              src: `${$props.imageUrl}?wid=240&hei=240`,
              alt: "product image",
              class: "product-card__img"
            }, null, 8 /* PROPS */, _hoisted_4))
          : (_openBlock(), _createElementBlock("img", {
              key: 2,
              src: `${$setup.fallbackImage}&hei=275`,
              alt: "No Image Available",
              class: "product-card__img"
            }, null, 8 /* PROPS */, _hoisted_5))
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, _toDisplayString($props.numberOfFinishes ? $props.numberOfFinishes : `0`) + " " + _toDisplayString($props.numberOfFinishes === 1 ? $props.translations.Finish : $props.translations.Finishes), 1 /* TEXT */),
        _createElementVNode("div", {
          class: _normalizeClass(["product-card__favorite-heart", $setup.addedToFavorites ? 'state-favorited' : '']),
          onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.addremoveFavorites($event, $props.product))),
          title: "Add to Favorites"
        }, null, 2 /* CLASS */)
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, _toDisplayString($props.title), 1 /* TEXT */)
      ])
    ], 2 /* CLASS */)
  ], 8 /* PROPS */, _hoisted_1))
}